import config from '../../config/config.json';
export {useStore} from 'effector-react';
export {$appStore} from '../../store/app/store';
export {getContent} from '../../service/httpService';

export const settings = config;
